import React from "react";

const DefaultGreyText = ({ text }) => {
    return <p className="default-grey-text">{text}</p>;
};

export default DefaultGreyText;
